import { render, staticRenderFns } from "./CancellationWorklist.vue?vue&type=template&id=bb8dce6e&"
import script from "./CancellationWorklist.vue?vue&type=script&lang=js&"
export * from "./CancellationWorklist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports